// Client TanStack Query (ADR 0013) : pas de nouvel essai sur une erreur 4xx ; 401 → session expirée.
import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { isApiError } from '@/lib/errors';
import { session } from './session';

function onError(error: unknown): void {
  if (isApiError(error) && error.kind === 'unauthenticated') session.markExpired();
}

export function createQueryClient(): QueryClient {
  return new QueryClient({
    queryCache: new QueryCache({ onError }),
    mutationCache: new MutationCache({ onError }),
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          if (isApiError(error) && error.status >= 400 && error.status < 500) return false;
          return failureCount < 2;
        },
      },
      mutations: { retry: false },
    },
  });
}
